<div class="my-5">
  <!-- page-header -->
  <sm-page-header [breadcrumb]="breadcrumb" [title]="title" description=""> </sm-page-header>
  <!-- content -->
  <div class="content">
    <sm-data-table-builder
      [dataTableObject]="datatableObject"
      [datas]="data"
      [totalRecords]="totalRecords"
      [loading]="loading"></sm-data-table-builder>
  </div>
  <sm-dialog #dialog [dialog]="dynamicFormDialog"></sm-dialog>
</div>
